import React from 'react'
import { 
  Button,
  Box,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Table,
  TableBody,
  TableHead,
  TablePagination,
  TableRow,
  TableCell,
  Tooltip,
  Typography
} from "@material-ui/core"
import Util from "../../common/Util"
import { TextField, Select } from "redux-form-material-ui";
import { Autocomplete } from "@material-ui/lab"
import DatePicker from "react-datepicker"
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment'
import ButtonCalendar from "../../components/ButtonCalendar/ButtonCalendar"
import { DELIVERED, ASSIGNED, ON_THE_WAY, CANCELED } from "../../common/Constants"

class DeliveryDetailDialog extends React.PureComponent{
  constructor(props){
    super(props)
    this.state = {page:0, rowPerPage:5, count:0, orders:[], clientFilter:"", restaurantFilter:[], dateFilter:new Date()}
    this.state[DELIVERED] = true
    this.state[ASSIGNED] = true
    this.state[ON_THE_WAY] = true
    this.state[CANCELED] = true
    this.onEnter = this.onEnter.bind(this)
    this.onChangeClient = this.onChangeClient.bind(this)
    this.onChangeAutocomplete = this.onChangeAutocomplete.bind(this)
    this.onDeleteChip = this.onDeleteChip.bind(this)
    this.onChangeDates=this.onChangeDates.bind(this)
    this.onChangeStateCheck = this.onChangeStateCheck.bind(this)
    this.onChangePage = this.onChangePage.bind(this)
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this)
    this.renderItems = this.renderItems.bind(this)
  }

  onEnter(){
    console.log("ON ENTER", this.props)
    let initState = {clientFilter:"", restaurantFilter:[], dateFilter:new Date()} 
    initState[DELIVERED] = true
    initState[ASSIGNED] = true
    initState[ON_THE_WAY] = true
    initState[CANCELED] = true
    this.setState(initState)
    this.onChangePage()
  }

  onChangeClient(evt){
    console.log("ONChange client", evt.target.value)
    this.setState({clientFilter:evt.target.value}, this.onChangePage)
  }

  onChangeAutocomplete(evt, newValue){
    if(newValue){
      const exist = this.state.restaurantFilter.some((r)=>{return r.id==newValue.id})
      // console.log("ON CHANGE AutoCOMPLETE", newValue, this.props.roles, exist)
      if(!exist){
        let r = this.state.restaurantFilter.slice(0)
        r.push(newValue)
        this.setState({restaurantFilter:r}, this.onChangePage)
      }
    }
  }

  onDeleteChip(item){
      const r = this.state.restaurantFilter.filter((r)=>{return r.id!=item.id})
      this.setState({restaurantFilter:r}, this.onChangePage)
  }

  onChangeDates(d){
    console.log("DATE", d)
    this.setState({dateFilter:d}, this.onChangePage)
  }

  onChangeStateCheck(check){
    let newState = {...this.state}
    newState[check] = !newState[check]
    console.log("ON CHANGE STATE", check, newState[DELIVERED],newState[ASSIGNED],newState[ON_THE_WAY],newState[CANCELED])
    if(!newState[DELIVERED]&&!newState[ASSIGNED]&&!newState[ON_THE_WAY]&&!newState[CANCELED]){
      if(check == DELIVERED){
        newState[ASSIGNED] = true
      }else{
        newState[DELIVERED] = true
      }
    }
    this.setState(newState, this.onChangePage)    
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let clientFilter = new RegExp(this.state.clientFilter,"ig")
    let restaurants = this.state.restaurantFilter
    let isBeequickDelivery = restaurants.some((r)=>{return r.id  == "Beequick"})
    let orders = this.props.orders.filter((o)=>{
      let add = this.state[o.tktState] &&
      (!this.state.clientFilter || o.tktBuyerName.match(clientFilter)||o.tktOwnerEmail.match(clientFilter) ) &&
      moment(this.state.dateFilter).isSame(Util.timestampToMoment(o.tktBuyDate),'day')
      if(add&&restaurants&&restaurants.length){
        if(isBeequickDelivery){
          add = o.restaurant&&!o.restaurant.resOnlyMyDeliverys || restaurants.some((r)=>{return r.id == o.evtId})
          console.log("RESTO BEEQUICK", add)
        }else{
          add = restaurants.some((r)=>{return r.id == o.evtId})
        }
      }
      return add
      
    })
    const count = orders.length
    orders = orders.slice(from, end)
    console.log("ORDERS", orders, count)
    this.setState({page:newPage, count:count, orders:orders})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let orders = []
    let clientFilter = new RegExp(this.state.clientFilter,"ig")
    orders = this.props.orders.filter((o)=>{
      return 
      moment(this.state.dateFilter).isSame(Util.timestampToMoment(o.tktBuyDate),'day') &&
      this.state.clientFilter&&( o.tktBuyerName.match(clientFilter)||o.tktOwnerEmail.match(clientFilter) ) &&
      this.state[o.tktState]      
    })
    const count = orders.length
    orders = orders.slice(from, end)
    this.setState({page:0, count:count, orders:orders})
  }

  renderItems(items){
    const { theme } = this.props
    console.log("ITEMS", items)
      return (
        <Table stickyHeader style={{marginTop:10}}>
          <TableHead>
            <TableRow>
              <TableCell>Comercio</TableCell>
              <TableCell>Pedido Nro.</TableCell>
              <TableCell>Hora de Compra</TableCell>
              <TableCell>Hora de Entrega</TableCell>
              <TableCell>Solicitado por</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items&&items.length>0?items.map((order, index)=>{
              return (
                <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
                  <TableCell>{order.restaurant&&order.restaurant.evtTitle}</TableCell>
                  <TableCell>{order.ordNumber}</TableCell>
                  <TableCell>{Util.timestampToMoment(order.tktBuyDate).format("HH:mm DD/MM")}</TableCell>
                  <TableCell>{order.tktControlTime&&Util.timestampToMoment(order.tktControlTime).format("HH:mm DD/MM")}</TableCell>
                  <TableCell>{order.tktBuyerName} ({order.tktOwnerEmail})</TableCell>
                  <TableCell>{Util.labelState(order.tktState)}</TableCell>
                  <TableCell>{Util.formatCurrency(order.ordTotal)}</TableCell>
                </TableRow>
              )
            })
            :
            <Typography style={{marginLeft:8}}>No se encontraron registros.</Typography>
          }
          </TableBody>
        </Table>
      )
  }

  render(){
    const { open, onClose, delivery} = this.props
    if(!delivery){
      return null
    }
    return (
      <Dialog open={open} style={{minWidth:900}} PaperProps={{style:{maxWidth:window.screen.availWidth, background:"#f6f6f6"}}} onEnter={this.onEnter}>
        <DialogTitle>
          <Typography variant="h1" color="primary">Histórico de pedidos de {delivery.profile.proName}</Typography>
        </DialogTitle>
        <DialogContent>
          <Card variant="outlined">
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={2}>
                  <InputLabel shrink style={{marginBottom:8}}>Fecha</InputLabel>
                  <DatePicker onChange={this.onChangeDates} 
                          selected={this.state.dateFilter}
                          // showMonthYearPicker={this.state.periodType=='monthly'}
                          // showWeekNumbers={this.state.periodType=='weekly'}
                          customInput={<ButtonCalendar from={this.state.dateFilter} period="dayly"/>}
                          maxDate={new Date()}
                          style={{zIndex:3}}
                          />
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    label="Solicitado por"
                    fullWidth
                    onChange = {this.onChangeClient}
                  />
                </Grid>
                <Grid item xs={5}>
                  <InputLabel shrink>Comercios</InputLabel>
                  <Autocomplete
                    autoComplete
                    options={delivery.restaurants}
                    getOptionLabel={option => option.evtTitle}
                    onChange={this.onChangeAutocomplete}
                    renderInput={params => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                  <Box className="top10">
                    {this.state.restaurantFilter.map((item,i)=>{
                      return <Chip key={`chip${i}`}
                                  color="primary" 
                                  label={item.evtTitle}
                                  onDelete={()=>{this.onDeleteChip(item)}} />
                    })} 
                  </Box>
                </Grid>
              </Grid>
              <Box style= {{display:"flex", justifyContent:"space-between"}}>
                <Box>  
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state[ASSIGNED]}
                        onChange={()=>this.onChangeStateCheck(ASSIGNED)}
                        color="primary"
                      />
                    }
                    label="Asignado"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state[ON_THE_WAY]}
                        onChange={()=>this.onChangeStateCheck(ON_THE_WAY)}
                        color="primary"
                      />
                    }
                    label="En camino"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state[DELIVERED]}
                        onChange={()=>this.onChangeStateCheck(DELIVERED)}
                        color="primary"
                      />
                    }
                    label="Entregado"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state[CANCELED]}
                        onChange={()=>this.onChangeStateCheck(CANCELED)}
                        color="primary"
                      />
                    }
                    label="Cancelado"
                  />
                </Box>
              </Box>
              
            
            {this.renderItems(this.state.orders)}
            <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={this.state.count}
                rowsPerPage={this.state.rowPerPage}
                page={this.state.page}
                onChangePage={this.onChangePage}
                onChangeRowsPerPage={this.onChangeRowsPerPage}
              />
             </CardContent>
          </Card>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cerrar">
            <Button variant="contained" color="secondary" onClick={onClose}>Cerrar</Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    )
  }
}

export default DeliveryDetailDialog


// WEBPACK FOOTER //
// ./src/screens/deliverys/DeliveryHistoryDialog.js